import {Component, Input} from '@angular/core';
import {IYii} from '../../../globals';
import {FormsModule} from '@angular/forms';
import {FormService} from '../services/FormService';
import {InputText} from 'primeng/inputtext';
import {Checkbox} from 'primeng/checkbox';
import {FieldService} from '../services/FieldService';

declare var Yii: IYii;

@Component({
  selector: 'ng-fields-config-common',
  templateUrl: './fields-config-common.html',
  imports: [
    FormsModule,
    InputText,
    Checkbox
  ]
})
export class FieldsConfigCommon {
  Yii = Yii
  @Input() field: any;

  constructor(
    public fsvc: FormService,
    private fields: FieldService
  ) {
  }

  public change() {
    this.fields.OnFieldChanged.emit(this.field);
  }

}
